var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_1671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1914 6.55078H21.4805V3.80859C21.4805 1.70854 19.7719 0 17.6719 0H8.32812C6.22807 0 4.51953 1.70854 4.51953 3.80859V6.55078H3.80859C1.70854 6.55078 0 8.25932 0 10.3594V16.4531C0 18.5532 1.70854 20.2617 3.80859 20.2617H4.51953V23.7148C4.51953 24.9749 5.54465 26 6.80469 26H19.1953C20.4553 26 21.4805 24.9749 21.4805 23.7148V20.2617H22.1914C24.2915 20.2617 26 18.5532 26 16.4531V10.3594C26 8.25932 24.2915 6.55078 22.1914 6.55078ZM6.04297 3.80859C6.04297 2.54856 7.06809 1.52344 8.32812 1.52344H17.6719C18.9319 1.52344 19.957 2.54856 19.957 3.80859V6.55078H6.04297V3.80859ZM19.957 23.7148C19.957 24.1349 19.6153 24.4766 19.1953 24.4766H6.80469C6.38468 24.4766 6.04297 24.1349 6.04297 23.7148V16.1992H19.957V23.7148ZM24.4766 16.4531C24.4766 17.7132 23.4514 18.7383 22.1914 18.7383H21.4805V16.1992H21.9375C22.3582 16.1992 22.6992 15.8582 22.6992 15.4375C22.6992 15.0168 22.3582 14.6758 21.9375 14.6758H4.0625C3.64183 14.6758 3.30078 15.0168 3.30078 15.4375C3.30078 15.8582 3.64183 16.1992 4.0625 16.1992H4.51953V18.7383H3.80859C2.54856 18.7383 1.52344 17.7132 1.52344 16.4531V10.3594C1.52344 9.09934 2.54856 8.07422 3.80859 8.07422H22.1914C23.4514 8.07422 24.4766 9.09934 24.4766 10.3594V16.4531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0312 17.9258H10.9688C10.5481 17.9258 10.207 18.2668 10.207 18.6875C10.207 19.1082 10.5481 19.4492 10.9688 19.4492H15.0312C15.4519 19.4492 15.793 19.1082 15.793 18.6875C15.793 18.2668 15.4519 17.9258 15.0312 17.9258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0312 21.1758H10.9688C10.5481 21.1758 10.207 21.5168 10.207 21.9375C10.207 22.3582 10.5481 22.6992 10.9688 22.6992H15.0312C15.4519 22.6992 15.793 22.3582 15.793 21.9375C15.793 21.5168 15.4519 21.1758 15.0312 21.1758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.80078H4.0625C3.64183 9.80078 3.30078 10.1418 3.30078 10.5625C3.30078 10.9832 3.64183 11.3242 4.0625 11.3242H6.5C6.92067 11.3242 7.26172 10.9832 7.26172 10.5625C7.26172 10.1418 6.92067 9.80078 6.5 9.80078Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_1671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.bab40ea416caff04589f87449582da22.svg";
export { ForwardRef as ReactComponent };